import Color from './color.js'

export default Color
